import { render } from "./ButtonRecentStrategies.vue?vue&type=template&id=90a204fe&scoped=true"
import script from "./ButtonRecentStrategies.vue?vue&type=script&lang=js"
export * from "./ButtonRecentStrategies.vue?vue&type=script&lang=js"

import "./ButtonRecentStrategies.vue?vue&type=style&index=0&id=90a204fe&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-90a204fe"

export default script